import {apolloClient} from '@/setup/apollo-setup';
import {getField, updateField} from "vuex-map-fields";
import * as _ from 'lodash';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';

import {
  ADD_TEACHER,
  DELETE_TEACHER,
  GET_TEACHERS,
  GET_TEACHERS_DDL,
  GET_TEACHERS_BY_FILTER,
  GET_TEACHER,
  UPDATE_TEACHER,
} from '@/queries/modules/profile/teacher';

//
// initial state
const state = {
  teacher: {
    id: "",
    code: "",
    facultyId: "",
    curriculumId: "",
    prefixId: "",
    firstNameLocal: "",
    lastNameLocal: "",
    firstNameEng: "",
    lastNameEng: "",
    availableTime: "",
    telephone: "",
    email: "",
    picturePath: "",
    socialMedia: "",
    isSpecialTeacher: null,
    isActive: null,
    userId: "",
  },
  teachers: [],
  teachersDdl: [],
  searchTeacherResults: [],
  processing: false,
  error: null,
  success: null,
};

//
// getters
const getters = {
  getField
};

//
// mutations
const mutations = {
  updateField,
  clearError: (state) => {
    state.error = null;
  },
  setError: (state, payload) => {
    state.error = payload;
    state.success = null;
    state.processing = false;
  },
  setSuccess: (state, payload) => {
    state.error = null;
    state.success = payload;
    state.processing = false;
  },
  setProcessing: (state, payload) => {
    state.processing = payload;
  },
  setTeachers: (state, payload) => {
    state.teachers = payload ? payload : [];
    state.searchTeacherResults = payload ? payload : [];
  },
  setTeachersDdl: (state, payload) => {
    state.teachersDdl = payload ? payload : [];
  },
  setTeacher: (state, payload) => {
    state.teacher = payload;
  },
  setSelectedTeacher: (state, payload) => {
    state.teacher = {...payload};
  },
  setSearchTeacherResults: (state, payload) => {
    state.searchTeacherResults = payload;
  },
  clearSelectedTeacher: (state) => {
    state.teacher = {
      id: "",
      code: "",
      facultyId: "",
      curriculumId: "",
      prefixId: "",
      firstNameLocal: "",
      lastNameLocal: "",
      firstNameEng: "",
      lastNameEng: "",
      availableTime: "",
      telephone: "",
      email: "",
      picturePath: "",
      socialMedia: "",
      isSpecialTeacher: null,
      isActive: null,
      userId: "",
    }
  }
};

//
// actions
const actions = {
  getTeachers: async ({commit}, useState = true) => {
    commit('setProcessing', true);
    try {
      const result = await apolloClient
        .query({
          query: GET_TEACHERS,
          fetchPolicy: 'network-only'
        });

      const { data, errors } = await result;

      if (errors) {
        commit('setError', error(errors));
        return state.teachers;
      }else{
        if(useState){
          commit('setTeachers', data.getTeachers);
        }
        commit('setSuccess', null);
        return data.getTeachers
      }

    } catch (e) {
      commit('setError', error(e));
      return state.teachers;
    }
  },
  getTeachersDdl: async ({commit}, useState = true) => {
    commit('setProcessing', true);
    try {
      const result = await apolloClient
        .query({
          query: GET_TEACHERS_DDL,
          fetchPolicy: 'network-only'
        });

      const { data, errors } = await result;

      if (errors) {
        commit('setError', error(errors));
        return state.teachersDdl;
      }else{
        if(useState){
          commit('setTeachersDdl', data.getTeachers);
        }
        commit('setSuccess', null);
        return data.getTeachers
      }

    } catch (e) {
      commit('setError', error(e));
      return state.teachersDdl;
    }
  },
  getTeachersByFilter: async ({commit}, payload) => {
    commit('setProcessing', true);

    apolloClient
      .query({
        query: GET_TEACHERS_BY_FILTER,
        variables: payload
      })
      .then(({data}) => {
        commit('setTeachers', data.getTeachersByFilter);
        commit('setSuccess', null);
      })
      .catch(({err}) => {
        commit('setError', error(err));
      });
  },
  getTeachersByFilterNotUseState: async ({commit}, payload) => {
    commit('setProcessing', true);
    try {
      const result = await apolloClient
        .query({
          query: GET_TEACHERS_BY_FILTER,
          variables: payload
        });
      const { data } = await result;
      commit('setSuccess', null);
      if (data && data.getTeachersByFilter.length > 0) {
        // TODO: Handle after success;
        return { status: { success: true, error: false, message: "" }, data: [...data.getTeachersByFilter] }
      } else {
        return { status: { success: false, error: true, code: 400, message: "no-result" }, data: []}
      }
    } catch (e) {
      commit('setError', error(e));
      return { status: { success: false, error: true, message: "", full: e }}
    }
  },
  getTeacher: async ({commit}, id) => {
    commit('setProcessing', true);

    apolloClient
      .query({
        query: GET_TEACHER,
        variables: {
          id: id
        }
      })
      .then(({data}) => {
        commit('setTeacher', data.getTeacher);
        commit('setSuccess', null);
      })
      .catch(({err}) => {
        commit('setError', error(err));
      });
  },
  searchTeachers: async ({commit}, payload) => {
    commit('setProcessing', true);

    try {
      commit('setSearchTeacherResults', _.filter(state.teachers, (teacher) => _.some(teacher, value => _.includes(_.toLower(value), _.toLower(payload)))));
      commit('setProcessing', false);
    } catch (err) {
      commit('setError', error(err));
    }
  },
  addTeacher: async ({commit}, payload) => {
    commit('setProcessing', true);

    await apolloClient
      .mutate({
        mutation: ADD_TEACHER,
        variables: payload,
      })
      .then(({data}) => {
        const teachers = [...state.teachers];
        teachers.push(data.addTeacher);
        commit('setTeachers', teachers);
        commit('setSuccess', newItemSuccess(data.addTeacher.nameLocal));
      })
      .catch((err) => {
        commit('setError', error(err));
      });
  },
  updateTeacher: async ({commit}, payload) => {
    commit('setProcessing', true);

    apolloClient
      .mutate({
        mutation: UPDATE_TEACHER,
        variables: payload
      })
      .then(({data}) => {
        const index = state.teachers.findIndex(teacher => teacher.id === data.updateTeacher.id);
        const teachers = [
          ...state.teachers.slice(0, index),
          data.updateTeacher,
          ...state.teachers.slice(index + 1)
        ];

        commit('setTeachers', teachers);
        commit('setSuccess', updateItemSuccess(data.updateTeacher.nameLocal));
      })
      .catch(({err}) => {
        commit('setError', error(err));
      });
  },
  deleteTeacher: async ({commit}, payload) => {
    commit('setProcessing', true);

    apolloClient
      .mutate({
        mutation: DELETE_TEACHER,
        variables: payload
      })
      .then(({data}) => {
        const index = state.teachers.findIndex(teacher => teacher.id === data.deleteTeacher.id);
        const teachers = [
          ...state.teachers.slice(0, index),
          ...state.teachers.slice(index + 1)
        ];

        commit('setTeachers', teachers);
        commit('setSuccess', deleteItemSuccess(data.deleteTeacher.nameLocal));
      })
      .catch(({err}) => {
        commit('setError', error(err));
      });
  },
  selectedTeacher: async ({commit}, payload) => {
    commit('setSelectedTeacher', payload);
  },
  clearSelectedTeacher: async ({commit}) => {
    commit('clearSelectedTeacher');
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
